import { Box, IconButton, Stack } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import FiltersSidebar from "../../Components/FiltersSidebar";
import useQueryState from "../../hooks/useQueryState";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";

const Dashboard = () => {
  const { pathname } = useLocation();
  const isGetStartedPage = pathname.includes("get-started");
  const {
    queryState: {
      ui: { mapSidebar },
    },
    queryState,
    setQueryState,
  } = useQueryState();

  const handleSidebar = () => {
    setQueryState({
      ui: {
        ...queryState.ui,
        mapSidebar: !mapSidebar,
      },
    });
  };

  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        minHeight: 0,
        overflowY: "auto",
        overflowX: "hidden",
        display: "flex",
      }}
    >
      {!isGetStartedPage && (
        <Box minWidth={0} minHeight={0}>
          <IconButton
            sx={{
              position: "absolute",
              zIndex: 9,
              backgroundColor: "#3f51b5",
              transform: `translate(${mapSidebar ? "305px" : "0px"}, 33vh)`,
              borderRadius: "0 6px 6px 0",
              padding: "5px",
              width: "25px",
              height: "50px",
              "&:hover": {
                backgroundColor: "#7d85b4",
              },
            }}
            onClick={handleSidebar}
          >
            {mapSidebar ? (
              <ChevronLeft sx={{ color: "white" }} />
            ) : (
              <ChevronRight sx={{ color: "white" }} />
            )}
          </IconButton>
          {mapSidebar && <FiltersSidebar />}
        </Box>
      )}
      <Stack
        direction="row"
        justifyContent="center"
        flex={1}
        sx={{ minWidth: 0, minHeight: 0 }}
      >
        <Outlet />
      </Stack>
    </Box>
  );
};

export default Dashboard;
